import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'healthOfficeVisits',
    label: 'Health Office Visits',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
